import moment from 'moment';

const formatDate = (date: string | number) => moment(date).format('ll');

const sortResourcesByDate = (a, b) => {
  const aDate = moment((a.generated && a.generated.date) || a.recordedAt);
  const bDate = moment((b.generated && b.generated.date) || b.recordedAt);
  if (aDate > bDate) return -1;
  if ((aDate && bDate) && aDate < bDate) return 1;
  return 0;
};

const sortRecordsByDate = (a, b) => {
  const aDate = moment(a.date
    || (a.pickup_at || a.tx_at)
    || (a.transactions && a.transactions.length > 0 && a.transactions[0].tx_at));
  const bDate = moment(b.date
    || (b.pickup_at || b.tx_at)
    || (b.transactions && b.transactions.length > 0 && b.transactions[0].tx_at));
  if (aDate > bDate) {
    return -1;
  }
  if ((aDate && bDate) && aDate < bDate) {
    return 1;
  }
  return 0;
};

const isAfter = (date) => moment().isAfter(moment(date), 'day');

/**
 * Returns the position where the cursor should be after formatting the date automatically
 * @param {*} newFormattedValue  is the formatted value for the user input
 * @param {*} previousFormattedValue  is the previous valid and formatted value that the user entered
 * @param {*} currentValue is the current value which may/maynot be formatted properly
 * @param {*} currentPosition is the current position of the cursor in the input
 */
const getCursorPositionForDateFormatting = (
  newFormattedValue: String,
  previousFormattedValue: String,
  currentValue: String,
  currentPosition: Number
) => {
  if (!previousFormattedValue || !previousFormattedValue.length) return 1;
  if (currentValue.length < previousFormattedValue.length) {
    if (newFormattedValue[currentPosition] === '-') {
      return currentPosition;
    }
  }
  if (newFormattedValue.length > currentValue.length) {
    if (currentPosition < 4) return currentPosition;
    return currentPosition + (newFormattedValue.length - currentValue.length);
  }
  if (currentPosition === 4 || currentPosition === 7) {
    return currentPosition + 1;
  }

  return currentPosition;
};

export { formatDate, sortRecordsByDate, isAfter, sortResourcesByDate, getCursorPositionForDateFormatting };


// WEBPACK FOOTER //
// ./src/utils/date-helpers.js